import { gql } from '@apollo/client';

export const createSoSupplementary = gql`mutation createSoSupplementary($input: CreateSoInput!) {
  createSo(input: $input)
}
`
